import React from 'react';

import { PATH } from 'src/pages/faq';
import Layout from 'src/components/layout';
import loadable from 'src/utils/loadable';
import { IRouter } from 'src/interfaces/route';

const FaqRoute: IRouter[] = [
  {
    element: <Layout />,
    children: [
      {
        path: PATH,
        element: loadable(() => import('src/pages/faq')),
        title: 'plugin.faq',
      },
    ],
  },
];

export default FaqRoute;
